import store from '../store'
import { createI18n } from 'vue-i18n'

const numberFormats = {
  'en-US': {
    currency: {
      style: 'currency', currency: 'USD', notation: 'standard'
    },
    decimal: {
      style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
    },
    percent: {
      style: 'percent', useGrouping: false
    }
  },
  'nl-NL': {
    currency: {
      style: 'currency', currency: 'EUR', useGrouping: true, currencyDisplay: 'symbol'
    },
    decimal: {
      style: 'decimal', minimumSignificantDigits: 2, maximumSignificantDigits: 2
    },
    percent: {
      style: 'percent', useGrouping: false
    }
  }
}


const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: 'nl-NL',
  messages: {},
  numberFormats: numberFormats
})

/**
 * @param {String} locale
 */
export async function loadMessages (locale) {

  /*
   * Load language files dynamically.
   * Iterate through ~/lang
   * https://vitejs.dev/guide/features.html#glob-import
   *
   * // code produced by vite
        const languageFiles = {
            '../lang/en.json': () => import('../lang/en.json'),
            '../lang/nl.json': () => import('../lang/nl.json')
        }

   */
    const objLanguageFiles = import.meta.glob('../lang/*.json')

    let languageFiles = Object.keys(objLanguageFiles).filter(key => {
        return key.indexOf(locale) !== -1
    })

    if (Object.keys(i18n.global.getLocaleMessage(locale)).length === 0) {
        let messagesMerged = {}

        /*
         * Create array of promises to feed Promise.all()
         */
        var promises = []
        languageFiles.forEach((file) => {
          // return promises.push(import(/* webpackChunkName: '' */ `../lang/${file}`))
            // Let op de haakjes: het is een functie die een promise teruggeeft
            return promises.push(objLanguageFiles[file]())
        })

        Promise.all(promises).then(values => {
          values.forEach(value => {
            messagesMerged = {...messagesMerged, ...value}
          })
           i18n.global.setLocaleMessage(locale, messagesMerged)
        })
    }

    if (i18n.global.locale.value !== locale) {
         i18n.global.locale.value = locale
    }
}

;(async function () {
  await loadMessages(store.getters['lang/locale'])
})()

export default i18n
